import { render, staticRenderFns } from "./DocProductType.vue?vue&type=template&id=69102f78"
import script from "./DocProductType.vue?vue&type=script&lang=js"
export * from "./DocProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports